import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useNavigation } from '../../../common/navigation';
import { ArticleMode } from '../../../common/spdCore/validation/schemas';

export const JudgmentsLink: React.FC<{
  examId: string;
  articleMode: ArticleMode;
  newWindow?: boolean;
}> = props => {
  const nav = useNavigation();

  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (props.articleMode === ArticleMode.Psychologist) {
      void nav.examPsychologistJudgments(props.examId, props.newWindow);
    }
    if (props.articleMode === ArticleMode.Doctor) {
      void nav.examDoctorJudgments(props.examId, props.newWindow);
    }
  };

  return (
    <>
      {(props.articleMode === ArticleMode.Doctor ||
        props.articleMode === ArticleMode.Psychologist) && (
        <OverlayTrigger overlay={<Tooltip>Edycja orzeczeń do badania</Tooltip>}>
          <Button onClick={handleOnClick} variant="btn-info">
            {props.newWindow ? (
              <Icon.BoxArrowUpRight />
            ) : (
              <Icon.Clipboard2Pulse />
            )}
          </Button>
        </OverlayTrigger>
      )}
    </>
  );
};
